// standalone file
let xhr = require('client/xhr');

let Spinner = require('client/spinner');
const LANG = require('config').lang;

let notification = require('client/notification');

module.exports = class FinalizeForm {

  constructor(options) {
    this.options = options;

    if (!options.successRedirect) {
      options.successRedirect = window.location.href;
    }

    this.elem = options.elem;

    this.elem.onsubmit = event => this.onSubmit(event);
  }

  successRedirect() {
    if (window.location.href == this.options.successRedirect) {
      window.location.reload();
    } else {
      window.location.href = this.options.successRedirect;
    }
  }

  request(options) {
    let request = xhr(options);

    request.addEventListener('loadstart', () => {
      let onEnd = this.startRequestIndication();

      request.addEventListener('fail', onEnd); // on success we redirect, no need to end the indication
    });

    return request;
  }

  startRequestIndication() {
    this.elem.classList.add('modal-overlay_light');

    let submitButton = this.elem.querySelector('[type="submit"]');

    let spinner;
    if (submitButton) {
      spinner = new Spinner({
        elem:      submitButton,
        size:      'small',
        class:     '',
        elemClass: 'button_loading'
      });
      spinner.start();
    }

    return () => {
      this.elem.classList.remove('modal-overlay_light');
      if (spinner) spinner.stop();
    };

  }

  onSubmit(event) {
    event.preventDefault();

    let payload = new FormData(this.elem);

    let request = this.request({
      method:         'POST',
      url:            '/auth/finalize',
      normalStatuses: [200, 400, 404],
      body:           payload
    });

    request.addEventListener('success', (event) => {

      if (request.status == 200) {
        this.successRedirect();
      } else {
        new notification.Error(event.result.error);
      }

    });

  }


};
